import { render, staticRenderFns } from "./CardCounter.vue?vue&type=template&id=008304e2&scoped=true&"
import script from "./CardCounter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CardCounter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CardCounter.vue?vue&type=style&index=0&id=008304e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008304e2",
  null
  
)

export default component.exports